import { useRouter } from 'next/router'
import useMapTagToWording from '../../../../modules/hooks/webview/caf/common/useMapTagToWording'
import HighlightPinCard from '../../../webview/caf/overview/HighlightPinCard'
import HighlightViewCard from '../../../webview/caf/overview/HighlightViewCard'

const ListItem = ({ item, onClickItem, isSelected, editable = false, tag, isStatistic }) => {
  const { countWordingPerTag, namePerTag, iconPerTag } = useMapTagToWording(!isStatistic)

  return editable ? (
    <HighlightPinCard
      isActive={item.average_count > 0}
      isSelected={item.is_pinned}
      upperTitle={{ text: namePerTag(item.tag), icon: iconPerTag(item.tag) }}
      mainText={
        item.average_count > 0
          ? countWordingPerTag(item.tag, item.average_count).count
          : countWordingPerTag(item.tag).noCount
      }
      onClick={() => null}
      tag={tag}
    />
  ) : (
    <HighlightViewCard
      isActive={item.average_count > 0}
      isSelected={isSelected}
      upperTitle={{ text: namePerTag(item.tag), icon: iconPerTag(item.tag) }}
      mainText={
        item.average_count > 0
          ? countWordingPerTag(item.tag, item.average_count).count
          : countWordingPerTag(item.tag).noCount
      }
      onClick={() => onClickItem(isSelected ? null : item.tag, item.id)}
    />
  )
}

const SortedHightlightListSection = ({ name, description, data, onClickItem, editable = false }) => {
  const router = useRouter()
  const selectedTag = router.query?.tag
  const isStatistic = !router.asPath.includes('/lessons/review') // !개별
  if (!data || data.length === 0) return null
  return (
    <div className="mt-[32px]">
      {!!name && (
        <div className="flex flex-row items-center justify-start">
          <span className="mr-[8px] text-[16px] font-bold text-purple-500">{name}</span>
          <span className=" text-[14px] font-normal text-gray-500">{description}</span>
        </div>
      )}
      <div className="mt-[14px] flex flex-col items-start justify-start">
        {data.map((item, i) => (
          <ListItem
            item={item}
            key={`${name || ''}list_item_${i}`}
            onClickItem={onClickItem}
            isSelected={+selectedTag === item.tag}
            editable={editable}
            tag={item.highlight_tag}
            isStatistic={isStatistic}
          />
        ))}
      </div>
    </div>
  )
}

export default SortedHightlightListSection
